<template>
  <div class="login">
    <div class="content">
      <div class="tab_box">
        <div class="tab_item fl" :class="{checked:isPassword}" @click="passwordLogin()">密码登录</div>
        <div class="tab_item fr" :class="{checked:!isPassword}" @click="noteLogin()">短信登录</div>
      </div>
      <div class="phone_box" v-if="isPassword">
        <i class="icon">
          <img src="../assets/img/icon_phone.png" alt>
        </i>
        <input v-model="params.username" class="input" type="text" placeholder="账号">
      </div>
      <div class="password_box" v-if="isPassword">
        <i class="icon">
          <img src="../assets/img/icon_phone.png" alt>
        </i>
        <input v-model="params.password" class="input" type="password" placeholder="密码">
      </div>
      <div class="phone_box" v-if="!isPassword">
        <i class="icon">
          <img src="../assets/img/icon_phone.png" alt>
        </i>
        <input v-model="params.username" class="input" type="tel" placeholder="手机号">
      </div>
      <div class="ident_box">
        <i class="icon">
          <img src="../assets/img/icon_code.png" alt>
        </i>
        <input v-model="params.verifyCode" class="input" type="text" placeholder="验证码">
        <img @click="getCode()" class="ident_img" :src="'data:image/png;base64,' + codeImg">
      </div>
      <div class="note_box" v-if="!isPassword">
        <i class="icon">
          <img src="../assets/img/icon_mail.png" alt>
        </i>
        <input v-model="params.smsCode" class="input" type="text" placeholder="短信验证码">
        <p @click="getMail">{{content}}</p>
        <!-- <p v-if="!getShow">{{time}}秒</p> -->
      </div>
      <div class="error_msg">
        <span v-show="error!= ''">{{error}}</span>
      </div>
      <a class="login_btn" href="javascript:;" @click="login">登录</a>
      <div class="tip_msg">
        <span>没有账号</span>
        <a
          href="javascript:;"
          @click="$router.push({name:'register',query:{fromDetail:fromDetail,from:from}})"
        >立即注册</a>
      </div>
    </div>
    <div class="dialog" v-if="goRigister">
      <div class="dialogBody">
        <div>该手机号尚未注册，请前往注册</div>
        <div class="btn_box" style="margin-top: 20px">
          <a href="javascript:;" @click="goRigister=false" style="margin-right: 20px;">取消</a>
          <a
            href="javascript:;"
            @click="$router.push({name:'register',query:{fromDetail:fromDetail,from:from}})"
          >确定</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setToken } from "../utils/auth";
export default {
  data() {
    return {
      isPassword: true,
      params: {
        username: "",
        password: "",
        verifyCode: "",
        smsCode: "",
        encryptVerifyCode: ""
      },
      codeImg: "",
      error: "",
      // time: 60,
      // getShow: true,

      content: "发送验证码",
      totalTime: 60,
      canClick: true,

      from: "",
      fromDetail: false,
      goRigister: false
    };
  },
  mounted() {
    this.fromDetail = this.$route.query.fromDetail;
    this.from = this.$route.query.from;
    this.getCode();
  },
  methods: {
    addVisibilitychange() {
      document.addEventListener("visibilitychange", function() {
        if (document.visibilityState == "hidden") {
          this.show = "hidden";
        } else {
          this.show = "visibility";
        }
      });
    },
    getMail() {
      if (!this.params.username) {
        this.error = "请输入手机号码";
        return;
      }
      if (!this.constant.validate.phone.test(this.params.username)) {
        this.error = "手机号输入有误，请重新输入";
        return;
      }
      this.$axios
        .get("/pub/sms/get-sms-code?phone=" + this.params.username)
        .then(res => {
          if (res.code != 200) {
            this.error = res.message;
          } else {
            this.timeReturn();
            // this.getShow = false;
          }
        });
    },
    timeReturn() {
      // let $this = this;
      // var d =  new Date();
      // var now = d.getTime();
      // var interval = setInterval(function(){
      //     var d =  new Date();
      //     var currTime = d.getTime();
      //     if ((currTime - now) > 1000) {
      //       console.log(now,currTime)
      //       $this.time--;
      //       if($this.time == 40){
      //         $this.getShow = true;
      //         clearInterval(interval);
      //       }
      //     }else if(1000 < (currTime - now) < 60000){
      //       $this.time = $this.time - Mail.floor(currTime - now)/1000 ;
      //       if($this.time == 40){
      //         $this.getShow = true;
      //         clearInterval(interval);
      //       }
      //     }else if(60000 < (currTime - now)){
      //       $this.getShow = true;
      //       clearInterval(interval);
      //     }
      // }, 1000)
      if (!this.canClick) return; 
      this.canClick = false;
      this.content = this.totalTime + "s";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.content = "重新发送";
          this.totalTime = 60;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
    },
    getCode() {
      this.$axios.get("/pub/verify_code/get-img").then(res => {
        this.codeImg = res.data.codePicBase64;
        this.params.encryptVerifyCode = res.data.code;
      });
    },
    passwordLogin() {
      this.error = "";
      this.isPassword = true;
    },
    noteLogin() {
      this.error = "";
      this.isPassword = false;
    },
    login() {
      this.error = "";
      if (this.isPassword) {
        if (!this.params.username) {
          this.error = "请输入手机号码";
          return;
        }
        if (!this.params.password) {
          this.error = "请输入密码";
          return;
        }
        if (!this.params.verifyCode) {
          this.error = "请输入验证码";
          return;
        }
        if (!this.constant.validate.phone.test(this.params.username)) {
          this.error = "手机号输入有误，请重新输入";
          return;
        }
        if (!this.constant.validate.password.test(this.params.password)) {
          this.error = "密码输入有误，请重新输入";
          return;
        }
        if (!this.constant.validate.verifyCode.test(this.params.verifyCode)) {
          this.error = "验证码输入有误，请重新输入";
          this.params.verifyCode = "";
          this.getCode();
          return;
        }
        this.error = "";
        var params = this.params;
        delete params.smsCode;
        // console.log('params', params)
        this.$axios.post("/api/web/phone/auth/login", params).then(res => {
          if (res.code != 200) {
            this.error = res.message;
          } else {
            this.Toast("登录成功");
            setToken(res.data.token);
            // console.log('token', res.data.token)
            if (this.fromDetail) {
              this.$router.go(-1);
            } else {
              if (!this.from) {
                this.$router.push("user");
              } else {
                this.$router.push(this.from);
              }
            }
          }
        });
      } else {
        if (!this.params.username) {
          this.error = "请输入手机号码";
          return;
        }
        if (!this.constant.validate.phone.test(this.params.username)) {
          this.error = "手机号输入有误，请重新输入";
          return;
        }
        if (!this.params.verifyCode) {
          this.error = "请输入验证码";
          return;
        }
        if (!this.params.smsCode) {
          this.error = "请输入短信验证码";
          return;
        }
        if (!this.constant.validate.verifyCode.test(this.params.verifyCode)) {
          this.error = "验证码输入有误，请重新输入";
          this.params.verifyCode = "";
          this.getCode();
          return;
        }
        this.error = "";
        var params = this.params;
        delete params.password;
        this.$axios.post("/api/web/phone/auth/login-sms", params).then(res => {
          // 账号不存在时
          if (res.code == 10006) {
            this.goRigister = true;
          } else if (res.code != 200 && res.code != 10006) {
            this.error = res.message;
          } else {
            this.Toast("登录成功");
            setToken(res.data.token);
            if (this.fromDetail) {
              this.$router.go(-1);
            } else {
              if (!this.from) {
                this.$router.push("user");
              } else {
                this.$router.push(this.from);
              }
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
.login {
  background: #f5f5f5;
  height: 100vh;
  padding: 99px 15px 0 15px;
  box-sizing: border-box;
}
.content {
  .tab_box {
    overflow: hidden;
    padding: 0 80px;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .tab_item {
    width: 83px;
    height: 30px;
    background: #f5f5f5;
    border-radius: 3px;
    font-size: 16px;
    color: #666666;
    line-height: 30px;
    text-align: center;
  }
  .tab_item.checked {
    background: #5fd5ca;
    color: #fff;
  }
  .input {
    width: 345px;
    height: 43px;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
    color: #999;
    padding-left: 54px;
    font-size: 14px;
    box-sizing: border-box;
  }
  .phone_box {
    margin-top: 24px;
    position: relative;
    .icon {
      display: inline-block;
      position: absolute;
      left: 15px;
      top: 11px;
      width: 13px;
      height: 21px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .password_box {
    margin-top: 24px;
    position: relative;
    .icon {
      display: inline-block;
      position: absolute;
      left: 15px;
      top: 11px;
      width: 13px;
      height: 21px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .ident_box {
    text-align: left;
    margin-top: 24px;
    position: relative;
    .icon {
      display: inline-block;
      position: absolute;
      left: 15px;
      top: 10px;
      width: 15px;
      height: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .input {
      width: 247px;
    }
    .ident_img {
      display: inline-block;
      position: absolute;
      right: 0;
      top: 2px;
      width: 88px;
      height: 38px;
      content: normal !important;
    }
  }
  .note_box {
    margin-top: 24px;
    position: relative;
    .icon {
      display: inline-block;
      position: absolute;
      left: 14px;
      top: 15px;
      width: 18px;
      height: 13px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .input {
      padding-right: 95px;
    }
    p {
      position: absolute;
      right: 0;
      display: inline-block;
      width: 92px;
      text-align: center;
      top: 13px;
      font-size: 12px;
      color: #5fd5ca;
      border-left: 1px solid #d8d8d8;
    }
  }
  .error_msg {
    color: #fd6262;
    font-size: 13px;
    padding-left: 66px;
    text-align: left;
    margin-top: 10px;
    min-height: 18px;
  }
  .login_btn {
    display: inline-block;
    width: 345px;
    height: 43px;
    line-height: 43px;
    background: #5fd5ca;
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    margin-top: 15px;
    text-align: center;
  }
  .tip_msg {
    margin-top: 31px;
    font-size: 14px;
    color: #999999;
    text-align: center;
    a {
      color: #5fd5ca;
      margin-left: 5px;
    }
  }
}
.dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  .dialogBody {
    width: 200px;
    margin: 0 auto;
    margin-top: 240px;
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    .btn_box a {
      padding: 2px 4px;
      /*border: 1px solid #D8D8D8;*/
      background: #fcfcfc;
      color: #5fd5ca;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue